import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { Calendar, Tag, ArrowRight, ArrowLeft } from 'lucide-react';
import { blogPosts } from '../servicesData';

export function BlogList() {
  return (
    <section className="bg-white py-14">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="text-xs text-slate-500 mb-4">
          <Link to="/" className="hover:text-orange-600">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">Blog</span>
        </nav>
        <div className="mb-10">
          <div className="text-xs font-bold uppercase tracking-widest text-orange-600">Register Point Blog</div>
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#0b3d5b] mt-2">Insights, guides &amp; updates</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">Stay ahead of tax deadlines, compliance changes and expert strategies for growing your business in India.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {blogPosts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all">
              <div className="h-32 bg-gradient-to-br from-orange-100 via-orange-50 to-white" />
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-slate-500">
                  <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {p.date}</span>
                  <span className="inline-flex items-center gap-1"><Tag className="w-3.5 h-3.5" /> {p.category}</span>
                </div>
                <h3 className="mt-3 font-bold text-[#0b3d5b] text-lg leading-snug group-hover:text-orange-600">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-orange-600">Read article <ArrowRight className="w-4 h-4" /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <article className="bg-white py-14">
      <div className="max-w-3xl mx-auto px-4">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-orange-600 hover:text-orange-700 font-semibold"><ArrowLeft className="w-4 h-4" /> All articles</Link>
        <div className="mt-6 flex items-center gap-3 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {post.date}</span>
          <span className="inline-flex items-center gap-1"><Tag className="w-3.5 h-3.5" /> {post.category}</span>
        </div>
        <h1 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0b3d5b] leading-tight">{post.title}</h1>
        <div className="mt-8 space-y-5">
          {post.body.map((para, i) => (
            <p key={i} className="text-slate-700 leading-relaxed text-[17px]">{para}</p>
          ))}
        </div>
        <div className="mt-12 p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-white border border-orange-100">
          <div className="font-bold text-[#0b3d5b] text-lg">Need expert help?</div>
          <p className="mt-1 text-sm text-slate-600">Talk to a verified CA on Register Point in minutes.</p>
          <Link to="/contact" className="mt-4 inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2.5 rounded-lg transition-colors">Get in touch</Link>
        </div>
      </div>
    </article>
  );
}
